import { Map } from 'react-loadable';

export const prefetch = () => import('./components/ProfileShare');

export const ProfileShare = Map({
  loader: {
    Module: prefetch,
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.ProfileShare {...props} />,
});

